import { set, values } from "lodash";
import { ValidationError } from "class-validator";
import { BaseFormData, FormErrors } from "./types";

/**
 * Validate a yup schema.
 */
export function validateYupSchema<T extends BaseFormData>(
  values: T,
  schema: any,
  sync = false,
  context: any = {}
): Promise<Partial<T>> {
  const validateData: Partial<T> = {};

  for (const key in values) {
    // eslint-disable-next-line no-prototype-builtins
    if (values.hasOwnProperty(key)) {
      validateData[key] = values[key] !== "" ? values[key] : undefined;
    }
  }

  return schema[sync ? "validateSync" : "validate"](validateData, {
    abortEarly: false,
    context
  });
}
/**
 * Transform Yup ValidationError to a more usable object
 */
export function yupToFormErrors<Values>(yupError: any): FormErrors<Values> {
  let errors: any = {} as FormErrors<Values>;

  if (yupError.inner.length === 0) {
    return set(errors, yupError.path, yupError.message);
  }

  for (const err of yupError.inner) {
    if (!errors[err.path]) {
      errors = set(errors, err.path, err.message);
    }
  }

  return errors;
}

export function classValidatorToFormErrors<T>(errs: ValidationError[]): FormErrors<T> {
  const errors = {} as FormErrors<T>;

  const addErr = (path: string, err: ValidationError) => {
    if (err.children.length > 0) {
      err.children.forEach((x) => addErr(`${path}.${x.property}`, x));
    } else {
      set(errors, `${path}`, values(err.constraints).join(","));
    }
  };
  errs.forEach((x) => addErr(`${x.property}`, x));
  return errors;
}

export const isObject = (obj: any): boolean => obj !== null && typeof obj === "object";

export const isPromise = (value: any): value is PromiseLike<any> =>
  isObject(value) && typeof value.then === "function";
